const GA4_ID = process.env.REACT_APP_GA4_ID;
const GADS_ID = process.env.REACT_APP_GADS_ID;
const GADS_LABEL = process.env.REACT_APP_GADS_LABEL;

export function trackPurchase({ transactionId, value, pack }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "purchase",
        ecommerce: {
            transaction_id: transactionId,
            currency: "EUR",
            value: value,
            items: [{ item_name: pack, quantity: 1 }],
        },
    });
    if (GA4_ID && typeof window.gtag === "function") {
        window.gtag("event", "purchase", {
            transaction_id: transactionId,
            currency: "EUR",
            value: value,
            items: [{ item_id: pack, item_name: pack, quantity: 1 }],
        });
    }
    if (GADS_ID && GADS_LABEL && typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
            send_to: `${GADS_ID}/${GADS_LABEL}`,
            value: value,
            currency: "EUR",
            transaction_id: transactionId,
        });
    }
}
